import { getShotgridEntitySchemas } from '@lib/api'
import { shotgridEntitySchemasKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useShotgridEntitySchemas = () => {
  return useQuery(shotgridEntitySchemasKeys.all, () =>
    getShotgridEntitySchemas(),
  )
}
